import { QRCodeSVG } from 'qrcode.react'

type Props = {
  token: string
  label?: string
  size?: 'default' | 'large'
}

/** QR handover asli (scannable). Mirror superoti-kitchen/src/shared/components/QrDisplay.tsx. */
export function QrDisplay({ token, label, size = 'default' }: Props) {
  const isLarge = size === 'large'
  const qrSize = isLarge ? 280 : 184

  return (
    <div className="flex flex-col items-center gap-3">
      <div className={`bg-white border-2 border-outline-variant rounded-xl shadow-sm ${isLarge ? 'p-6' : 'p-4'}`}>
        <QRCodeSVG value={token} size={qrSize} level="M" marginSize={0} bgColor="#ffffff" fgColor="#000000" />
      </div>
      {!isLarge && (
        <p className="font-mono text-label-md text-center break-all px-2 text-inherit opacity-80">{token}</p>
      )}
      {label && (
        <p
          className={`text-center ${
            isLarge ? 'text-body-lg text-white font-semibold' : 'text-body-sm text-inherit opacity-90'
          }`}
        >
          {label}
        </p>
      )}
    </div>
  )
}
